import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { detectLocationFromIP } from "@/lib/time";
import { toast } from "sonner";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const { loginWithGoogleSession } = useAuth();
  const navigate = useNavigate();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = window.location.hash || "";
    const m = hash.match(/session_id=([^&]+)/);
    if (!m) {
      navigate("/login", { replace: true });
      return;
    }
    const session_id = decodeURIComponent(m[1]);

    (async () => {
      try {
        const { country, timezone } = await detectLocationFromIP();
        await loginWithGoogleSession(session_id, country, timezone);
        toast.success("Signed in with Google");
        // Clear hash & redirect home
        window.history.replaceState(null, "", window.location.pathname);
        navigate("/", { replace: true });
      } catch (e) {
        toast.error("Google sign-in failed");
        navigate("/login", { replace: true });
      }
    })();
  }, [loginWithGoogleSession, navigate]);

  return (
    <div className="min-h-screen bg-white text-slate-900 flex items-center justify-center" data-testid="auth-callback">
      <div className="text-center">
        <div className="w-10 h-10 border-2 border-slate-200 border-t-blue-600 rounded-full animate-spin mx-auto mb-4" />
        <p className="text-xs uppercase tracking-wider text-slate-400">
          Signing you in…
        </p>
      </div>
    </div>
  );
}
